import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { UI_SUBSCRIPTION } from '../testTab/constants';

export const SUBSCRIPTION_TOGGLE = {
  PRIME: 'prime',
  PLUS_ICONIC: 'plus_iconic'
};

const OPTIONS = [
  { id: SUBSCRIPTION_TOGGLE.PRIME, label: 'Prime' },
  { id: SUBSCRIPTION_TOGGLE.PLUS_ICONIC, label: 'Plus & Iconic' }
];

const Switcher = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  box-sizing: border-box;
  padding: 4px;
  border-radius: 999px;
  background: var(--color-divider);

  ${mediaQuery.uptoMobile} {
    display: flex;
    width: 100%;
  }
`;

const TabButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  min-width: 148px;
  border: none;
  cursor: pointer;
  padding: 10px ${Spacings.SPACING_6B};
  border-radius: 999px;

  ${mediaQuery.uptoMobile} {
    flex: 1;
    min-width: 0;
  }
  background: ${({ $isActive }) =>
    $isActive ? 'var(--color-base-1)' : 'transparent'};
  box-shadow: ${({ $isActive }) =>
    $isActive ? '0 1px 3px var(--color-shadow)' : 'none'};
  transition: background 0.2s ease, box-shadow 0.2s ease;

  &:focus-visible {
    outline: 2px solid var(--color-accent-blue);
    outline-offset: 2px;
  }
`;

const TabLabel = styled.span`
  font-size: 16px;
  line-height: 20px;
  font-weight: ${Fonts.SEMIBOLD};
  color: ${({ $isActive }) =>
    $isActive ? 'var(--color-accent-blue)' : 'var(--color-text-secondary)'};
  white-space: nowrap;
`;

export const getSubscriptionToggleValue = (selectedIds = []) => {
  if (
    selectedIds.includes(UI_SUBSCRIPTION.PLUS) ||
    selectedIds.includes(UI_SUBSCRIPTION.ICONIC)
  ) {
    return SUBSCRIPTION_TOGGLE.PLUS_ICONIC;
  }

  return SUBSCRIPTION_TOGGLE.PRIME;
};

export const getSubscriptionIdsForToggle = (toggleValue) =>
  toggleValue === SUBSCRIPTION_TOGGLE.PLUS_ICONIC
    ? [UI_SUBSCRIPTION.PLUS, UI_SUBSCRIPTION.ICONIC]
    : [UI_SUBSCRIPTION.PRIME];

const SubscriptionToggle = ({ value, onChange }) => (
  <Switcher role="tablist" aria-label="Subscription type">
    {OPTIONS.map(({ id, label }) => {
      const isActive = value === id;

      return (
        <TabButton
          key={id}
          type="button"
          role="tab"
          aria-selected={isActive}
          $isActive={isActive}
          onClick={() => {
            if (!isActive) onChange(id);
          }}
        >
          <TabLabel $isActive={isActive}>{label}</TabLabel>
        </TabButton>
      );
    })}
  </Switcher>
);

export default SubscriptionToggle;

SubscriptionToggle.propTypes = {
  value: PropTypes.oneOf(Object.values(SUBSCRIPTION_TOGGLE)).isRequired,
  onChange: PropTypes.func.isRequired
};
